
<template>
  <div>
    <header-group>
    </header-group>
    <div>
      <img src="../assets/1639745877778799.jpg" style="width: 100%; display:block">
    </div>
    <breadcrumb :breadcrumbs=breadcrumbs :button="button">
    </breadcrumb>

    <div class="index-news">
      <div class="index-title">
        <p class="t1" style="color: black;">执享信息</p>
        <div class="displayF" style="margin-top: 15px">
          <div style="background: #ef801a; height: 2px;width: 54px;top: 50%; right: 50%"></div>
        </div>
        <div class="grid-container">
          <div v-for="(item, i) in imgData" :key="i" class="grid-item">
            <img-group :img="item"></img-group>
          </div>
        </div>
      </div>
      <page></page>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import HeaderGroup from "@/components/HeaderGroup.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Bottom from "@/components/Bottom.vue";
import ImgGroup from "@/components/ImgGroup.vue";
import Page from "@/components/page.vue";

export default {
  name: 'about',
  components: {Page, ImgGroup, Bottom, Breadcrumb,HeaderGroup},
  data() {
    return {
      breadcrumbs: [{name:'首页',path:'/'},{name:'服务项目',path:'/service'}],
      button:[],
      imgData: [
        {img: require("@/assets/faxing.png"), name: "游戏发行"},
        {img: require("@/assets/shujuwajue.jpg"), name: "数据挖掘"},
        {img: require("@/assets/ruanjiankaifa.jpg"), name: "软件开发"},
        {img: require("@/assets/rengongzhineng.jpg"), name: "人工智能"}
      ],
    }
  }


}

</script>
<style scoped>

.index-news {
  padding: 10px 0 70px 0;
  background: white;
}
.index-title {
  padding: 60px 0;
  text-align: center;
  align-items: center;
  position: relative;
  line-height: 30px
}

.displayF {
  display: flex;
  justify-content: center;
}

.t1 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 两列 */
  grid-template-rows: repeat(2, 1fr); /* 两行 */
  gap: 20px; /* 项目间距 */
  max-width: 1000px; /* 控制整体宽度 */
  margin: 0 auto; /* 水平居中 */
  padding: 20px; /* 内边距 */
}




.grid-item {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* 防止内容溢出 */
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
}
</style>